<template>
    <div class="animated fadeIn">

        <h4>Dashboard Financeiro - FreeFlow</h4>

                <b-row>
                    <b-col cols="auto" class="mr">
                        <b-form-group>
                            <label for="startDate">Período</label>
                            <b-form-input v-model="filters.startDate" type="date" id="startDate"></b-form-input>
                        </b-form-group>
                    </b-col>
                    <b-col cols="auto" class="mr">
                        <b-form-group>
                            <label for="endDate">&nbsp;</label>
                            <b-form-input v-model="filters.endDate" type="date" id="endDate"></b-form-input>
                        </b-form-group>
                    </b-col>
                    <b-col cols="auto" class="mr-auto" style="padding-top: 12px;">
                        <b-form-group>
                            <p></p>
                            <b-button variant="stack-overflow" class="mr-1 btn-brand" @click="refreshData()"><i class="fa fa-search"></i><span>Localizar</span></b-button>
                        </b-form-group>
                    </b-col>
                
                </b-row>

        <ul class="nav nav-tabs">
            <li class="nav-item">
                <a class="nav-link" aria-current="page" href="#"  :class="tabInfo=='G' ? 'active' : ''" @click="tabInfo='G'">Visão Geral Financeira</a>
            </li>
            <li class="nav-item">
                <a class="nav-link" href="#" :class="tabInfo=='S' ? 'active' : ''" @click="tabInfo='S'">Desempenho de Vendas</a>
            </li>
            <li class="nav-item">
                <a class="nav-link" href="#" :class="tabInfo=='O' ? 'active' : ''" @click="tabInfo='O'">Eficiência Operacional</a>
            </li>
        </ul>

        <p></p>
        
            <div v-show="tabInfo=='G'">
                <b-row>
                    <b-col v-for="item in totals" :key="item.label">
                        <b-card class="text-center" :class="item.color">
                            <p class="card-title">{{ item.label }}</p>
                            <h4 class="card-text">{{ item.prefix }}{{ $utils.numberFormat(item.value) }}{{ item.suffix }}</h4>
                        </b-card>  
                    </b-col>
                </b-row>

                <b-row>
                    <b-col sm="12" md="6" lg="8">
                        <b-card >
                            <b-row>
                                <b-col sm="5">
                                <h4 id="traffic" class="card-title mb-0">Receita Total vs Lucro Líquido</h4>
                                <div class="small text-muted">{{ D1C1.subtitle }}</div>
                                </b-col>
                                <b-col sm="7" class="d-none d-md-block">
                                    <!--
                                <b-button type="button" variant="primary" class="float-right"><i class="icon-cloud-download"></i></b-button>
                                <b-button-toolbar class="float-right" aria-label="Toolbar with buttons group">
                                    <b-form-radio-group class="mr-3" id="radiosBtn" buttons button-variant="outline-secondary" v-model="selected" name="radiosBtn">
                                    
                                    <b-form-radio class="mx-0" value="Day">Day</b-form-radio>
                                    <b-form-radio class="mx-0" value="Month">Month</b-form-radio>
                                    <b-form-radio class="mx-0" value="Year">Year</b-form-radio>
                                    </b-form-radio-group>
                                </b-button-toolbar>
                                -->
                                </b-col>
                            </b-row>

                            <A6LineChart key="chartD1C1" ref="chartD1C1" chartId="main-chart-1-01" class="chart-wrapper"
                               style="height:300px;margin-top:40px;" height="300"
                               :obj = "D1C1"
                               :labelYLeft = "D1C1.axisYLeftLabel"
                               :maxValue = "2000000"
                            ></A6LineChart>

                            <div slot="footer" style="height:85px;">
                                <b-row class="text-center">
                                    <b-col class="mb-sm-2 mb-0" v-for="(item, index) in regionTotal" :key="index">
                                        <div class="text-muted">{{ item.label }}</div>
                                        <strong>R$ {{ $utils.numberFormat(item.value) }}
                                            <br>{{ $utils.numberFormat(item.percentage) }} %
                                        </strong>
                                        <b-progress height={} class="progress-xs mt-2" :precision="1" :variant="item.color" :value="item.percentage"></b-progress>
                                    </b-col>
                                </b-row>
                            </div>
                        </b-card>
                    </b-col>
                    <b-col sm="12" md="6" lg="4">
                        <b-card>
                            <b-row>
                                <b-col sm="5">
                                <h4 id="traffic" class="card-title mb-0">Período</h4>
                                <div class="small text-muted">&nbsp;</div>
                                </b-col>a
                                <b-col sm="7" class="d-none d-md-block">
                                <!--
                                <b-button type="button" variant="primary" class="float-right"><i class="icon-cloud-download"></i></b-button>
                                <b-button-toolbar class="float-right" aria-label="Toolbar with buttons group">
                                    <b-form-radio-group class="mr-3" id="radiosBtn" buttons button-variant="outline-secondary" v-model="selected" name="radiosBtn">                                    
                                    </b-form-radio-group>
                                </b-button-toolbar>
                                
                                -->
                                </b-col>
                            </b-row>
                            <dash1-chart2 chartId="chart-bar-01" title="" value="-26000000" style="height:300px;margin-top:40px;" height="300" />
                            <div slot="footer" style="height:85px;" >
                                <!--                                <b-row class="text-center">
                                    <b-col class="mb-sm-2 mb-0" v-for="(item, index) in regionTotal" :key="index">
                                        <div class="text-muted">{{ item.label }}</div>
                                        <strong>R$ {{ $utils.numberFormat(item.value) }}
                                            <br>{{ $utils.numberFormat(item.percentage) }} %
                                        </strong>
                                        <b-progress height={} class="progress-xs mt-2" :precision="1" :variant="item.color" :value="item.percentage"></b-progress>
                                    </b-col>
                                </b-row>
                                -->

                            </div>
                        </b-card>
                    </b-col>
                </b-row>    
            </div>
            <div v-show="tabInfo=='S'">
                <b-row>
                    <b-col sm="12" md="6">
                        <b-card >
                            <b-row>
                                <b-col sm="12">
                                <h4 id="traffic" class="card-title mb-0">{{ D2C1.title }}</h4>
                                <div class="small text-muted">{{ D2C1.subtitle }}</div>
                                </b-col>
                                <b-col sm="7" class="d-none d-md-block">
                               
                                </b-col>
                            </b-row>
                            <A6BarChart key="chartD2C1" ref="chartD2C1" chartId="main-chart-01" class="chart-wrapper"
                               style="height:300px;margin-top:40px;" height="300"
                               :obj = "D2C1"
                               :labelYLeft = "D2C1.axisYLeftLabel"
                               :maxValue = "210000"                            
                            ></A6BarChart>
                            
                        </b-card>
                    </b-col>
                    <b-col sm="12" md="6">
                        <b-card >
                            <b-row>
                                <b-col sm="12">
                                <h4 id="traffic" class="card-title mb-0">{{ D2C2.title }}</h4>
                                <div class="small text-muted">{{ D2C2.subtitle }}</div>
                                </b-col>
                                <b-col sm="7" class="d-none d-md-block">
                               
                                </b-col>
                            </b-row>
                            <A6BarChart key="chartD2C2" ref="chartD2C2" chartId="main-chart-01" class="chart-wrapper"
                               style="height:300px;margin-top:40px;" height="300"
                               :obj = "D2C2"
                               :labelYLeft = "D2C2.axisYLeftLabel"
                               :maxValue = "10000000"
                            ></A6BarChart>
                            
                        </b-card>
                    </b-col>
                </b-row>

                <b-row>
                    <b-col sm="12" md="6">
                        <b-card >
                            <b-row>
                                <b-col sm="12">
                                <h4 id="traffic" class="card-title mb-0">{{ D2C3.title }}</h4>
                                <div class="small text-muted">{{ D2C3.subtitle }}</div>
                                </b-col>
                                <b-col sm="7" class="d-none d-md-block">
                            
                                </b-col>
                            </b-row>
                            <A6LineChart key="chartD2C3" ref="chartD2C3" chartId="main-chart-2-03" class="chart-wrapper"
                               style="height:300px;margin-top:40px;" height="300"
                               :obj = "D2C3"
                               :labelYLeft = "D2C3.axisYLeftLabel"
                               :minValue = "25"
                               :maxValue = "50"
                            ></A6LineChart>
                            
                        </b-card>
                    </b-col>
                    <b-col sm="12" md="6">
                        <b-card >
                            <b-row>
                                <b-col sm="12">
                                <h4 id="traffic" class="card-title mb-0">{{ D2C4.title }}</h4>
                                <div class="small text-muted"></div>
                                </b-col>
                                <b-col sm="7" class="d-none d-md-block">
                                
                                </b-col>
                            </b-row>
                            <A6LineChart key="chartD2C4" ref="chartD2C4" chartId="main-chart-2-04" class="chart-wrapper"
                               style="height:300px;margin-top:40px;" height="300"
                               :obj = "D2C4"
                               :labelYLeft = "D2C4.axisYLeftLabel"
                               :minValue = "25"
                               :maxValue = "50"
                            ></A6LineChart>
                            
                        </b-card>
                    </b-col>
                    
                </b-row>

                <b-row>
                    <b-col sm="12" md="6">
                        <b-card>
                            <b-row>
                                <b-col sm="12">
                                <h4 id="traffic" class="card-title mb-0">{{ D2C5.title }}</h4>
                                <div class="small text-muted"></div>
                                </b-col>
                                <b-col sm="7" class="d-none d-md-block">
                                 
                                </b-col>
                            </b-row>
                            <A6BarChart key="chartD2C5" ref="chartD2C5" chartId="main-chart-05" class="chart-wrapper"
                               style="height:300px;margin-top:40px;" height="300"
                               :obj = "D2C5"
                               :labelYLeft = "D2C5.axisYLeftLabel"
                               :maxValue = "4500000"
                            ></A6BarChart>
                            
                        </b-card>
                    </b-col>
                    <b-col sm="12" md="6">
                        <b-card style="height:405px;">
                            <b-row>
                                <b-col sm="12">
                                <h4 id="traffic" class="card-title mb-0">Top 5 Produtos (Receita)</h4>
                                <div class="small text-muted"></div>
                                </b-col>
                                <b-col sm="7" class="d-none d-md-block">                                 
                                </b-col>
                            </b-row>
                            <A6Table :items="items"></A6Table>
                        </b-card>
                    </b-col>
                </b-row>
                            

            </div>
            <div v-show="tabInfo=='O'">
                 <b-row>
                    <b-col v-for="item in totals2" :key="item.label">
                        <b-card class="text-center" :class="item.color">
                            <p class="card-title">{{ item.label }}</p>
                            <h4 class="card-text">{{ item.prefix }}{{ $utils.numberFormat(item.value) }}{{ item.suffix }}</h4>
                        </b-card>  
                    </b-col>
                </b-row>

                <b-row>
                    <b-col sm="12" md="6">
                        <b-card>
                            <b-row>
                                <b-col sm="12">
                                <h4 id="traffic" class="card-title mb-0">CPV vs. Margem Bruta Média Mensal</h4>
                                <div class="small text-muted"></div>
                                </b-col>
                                <b-col sm="7" class="d-none d-md-block">
                                 
                                </b-col>
                            </b-row>
                            <A6BarChart key="chartD3C1" ref="chartD3C1" chartId="main-chart-3-01" class="chart-wrapper"
                               style="height:300px;margin-top:40px;" height="300"
                               :obj = "D3C1"
                               :labelYLeft = "D3C1.axisYLeftLabel"
                               :maxValue = "1000000"
                            ></A6BarChart>
                            
                        </b-card>
                    </b-col>
                    <b-col sm="12" md="6">
                        <b-card style="height:405px;">
                            <b-row>
                                <b-col sm="12">
                                <h4 id="traffic" class="card-title mb-0">{{ D3C2.title }}</h4>
                                <div class="small text-muted">{{ D3C2.subtitle }}</div>
                                </b-col>
                                <b-col sm="7" class="d-none d-md-block">
                                 
                                </b-col>
                            </b-row>
                            <A6LineChart key="chartD3C2" ref="chartD3C2" chartId="main-chart-3-02" class="chart-wrapper"
                               style="height:300px;margin-top:40px;" height="300"
                               :obj = "D3C2"
                               :labelYLeft = "D3C2.axisYLeftLabel"
                               :maxValue = "10"
                            ></A6LineChart>
                        </b-card>
                    </b-col>
                </b-row>

                <b-row>
                    <b-col sm="12">
                        <b-card>
                            <b-row>
                                <b-col sm="12">
                                <h4 id="traffic" class="card-title mb-0">Prazo Médio de Recebimento Mensal (dias)</h4>
                                <div class="small text-muted"></div>
                                </b-col>
                                <b-col sm="7" class="d-none d-md-block">
                                 
                                </b-col>
                            </b-row>
                            <A6LineChart key="chartD3C3" ref="chartD3C3" chartId="main-chart-3-03" class="chart-wrapper"
                               style="height:300px;margin-top:40px;" height="300"
                               :obj = "D3C3"
                               :labelYLeft = "D3C3.axisYLeftLabel"
                               :maxValue = "18"
                            ></A6LineChart>
                            
                        </b-card>
                    </b-col>
                </b-row>
            </div>
        

    </div>
</template>

<script>
import Vue from 'vue'
import axios from "axios";
import MaskedInput from 'vue-text-mask'
import vSelect from 'vue-select'
import { Switch as cSwitch } from '@coreui/vue'
import VueGauge from 'vue-gauge'

import A6Table from './charts/A6Table'
import A6BarChart from './charts/A6BarChart'
import A6LineChart from './charts/A6LineChart.vue';


import Dash1Chart2 from './charts/Dash1Chart2'

/* Toast */
import VueNotifications from 'vue-notifications'
import miniToastr from 'mini-toastr' // https://github.com/se-panfilov/mini-toastr

//import { table } from 'console'

const toastTypes = {
    success: 'success',
    error: 'error',
    info: 'info',
    warn: 'warn'
}

miniToastr.init({ types: toastTypes })

function toast({ title, message, type, timeout, cb }) {
    return miniToastr[type](message, title, timeout, cb)
}

const options = {
    success: toast,
    error: toast,
    info: toast,
    warn: toast
}
VueNotifications.setPluginOptions(options)

Vue.use(VueNotifications, options)
/* Toast - End */


export default {
    name: 'tables',
    components: {
        Event,
        cSwitch,
        MaskedInput,
        vSelect,
        Dash1Chart2,
        A6Table,
        A6BarChart,
        A6LineChart,
        VueGauge
        
    },
    data: () => {
        return { 
            items: [],
            speedometerValue: 15,          
            perPage: 50, 
            tabInfo: 'G',
            filters: {
                startDate: (() => {
                    const d = new Date();
                    d.setMonth(d.getMonth() - 4);
                    return d.toISOString().split('T')[0];
                })(),
                endDate: new Date().toISOString().split('T')[0] // Default to today
            },

            regionTotal: [
                {
                    label: 'Sul',
                    value: 300000.00,
                    percentage: 15,
                    color: 'success'
                },
                {
                    label: 'Sudeste',
                    value: 300000.00,
                    percentage: 25,
                    color: 'info'
                },
                {
                    label: 'Norte',
                    value: 300000.00,
                    percentage: 14,
                    color: 'warning'
                },
                {
                    label: 'Nordeste',
                    value: 300000.00,
                    percentage: 42,
                    color: 'danger'
                },
                {
                    label: 'Centro-Oeste',
                    value: 300000.00,
                    percentage: 21,
                    color: 'secondary'
                }
            ],

            totals: [
                {
                    label: 'Receita Total',
                    value: 31956232.00,
                    prefix: 'R$ ',
                    color: 'bg-primary'
                },
                {
                    label: "Margem Contribuição Total",
                    value: 14544454.00,
                    prefix: 'R$ ',
                    color: 'bg-primary'
                },
                {
                    label: 'Margem Cotribuição %',
                    value: 45.5,
                    suffix: '%',
                    color: 'bg-primary'
                },
                {
                    label: 'Margem Líquida Média',
                    value: 18.1,
                    suffix: '%',
                    color: 'bg-primary'
                },
                {
                    label: "EBITDA Total",
                    value: 8117956.30,
                    prefix: 'R$ ',
                    color: 'bg-primary'
                }

            ],

            totals2: [
                {
                    label: 'Dias de Estoque Médio (Dias)',
                    value: 67.1,
                    suffix: ' dias',
                    color: 'bg-primary'
                },
                {
                    label: "Taxa de Ruptura de Estoque",
                    value: 5.6,
                    suffix: '%',
                    color: 'bg-primary'
                }
            ],

            D1C1: {},
            D2C1: {},
            D2C2: {},
            D2C3: {},
            D2C4: {},
            D2C5: {},
            D3C1: {},
            D3C2: {},
            D3C3: {},

            dash2chart1: {
                labelYLeft: 'Volume de Vendas (R$)',
                minValue: 0,
                maxValue: 200000,
                labels: ['Shampoos', 'Condicionadores', 'Colorações', 'Tratamentos', 'Finalizadores'],
                data: [199540, 175382, 161231, 147721, 132886],
                color: '#20a8d8'
            }
            
        }
    },
    computed: {
    
    },
    methods: {    
        async getChart(code) {
            var s = this
            
            await axios.get(this.$store.state.ws_url + "/dashboard/chart", {
                params: {
                    code: code,
                    startDate: this.filters.startDate,
                    endDate: this.filters.endDate,
                    uid: 1,
                    sid: 123213213123
                }
            }).then(function (resp) {
                //console.log(resp.data.obj);
                if(code == 'D1C1') {
                    s.D1C1 = { ...resp.data.obj }
                    s.$refs.chartD1C1.refreshChart()
                }
                else if(code == 'D2C1') {
                    s.D2C1 = { ...resp.data.obj }
                    s.$refs.chartD2C1.refreshChart()
                }
                else if(code == 'D2C2') {
                    s.D2C2 = { ...resp.data.obj };
                    s.$refs.chartD2C2.refreshChart()
                }
                else if(code == 'D2C3') {
                    s.D2C3 = { ...resp.data.obj };
                    s.$refs.chartD2C3.refreshChart()
                }
                else if(code == 'D2C4') {
                    s.D2C4 = { ...resp.data.obj };
                    s.$refs.chartD2C4.refreshChart()
                }
                else if(code == 'D2C5') {
                    s.D2C5 = { ...resp.data.obj };
                    s.$refs.chartD2C5.refreshChart()
                }
                else if(code == 'D3C1') {
                    s.D3C1 = { ...resp.data.obj };
                    s.$refs.chartD3C1.refreshChart()
                }
                else if(code == 'D3C2') {
                    s.D3C2 = { ...resp.data.obj };
                    s.$refs.chartD3C2.refreshChart()
                }
                else if(code == 'D3C3') {
                    s.D3C3 = { ...resp.data.obj };
                    s.$refs.chartD3C3.refreshChart()
                }
            }
            ).catch(function (error) {
                console.log(error.message);            
            });
                
        },

        async getTotal(totalTypeId) {
            var s = this
            
            await axios.get(this.$store.state.ws_url + "/dashboard/total", {
                params: {
                    type: totalTypeId,
                    startDate: this.filters.startDate,
                    endDate: this.filters.endDate,
                    uid: 1,
                    sid: 123213213123
                }
            }).then(function (resp) {
                //console.log(resp.data.obj);
                if(totalTypeId == 1) {
                    s.totals = resp.data.obj;
                } else if(totalTypeId == 2) {
                    s.regionTotal = resp.data.obj;
                }
                else if(totalTypeId == 3) {
                    s.totals2 = resp.data.obj;
                }
            }
            ).catch(function (error) {
                console.log(error.message);            
            });
                
        },

        async refreshDataTable() {
            var s = this;
            var currentUser = this.$store.state.currentUser;

            console.log(this.$store.state.ws_url + "/dashboard/data?uid=1&sid=1232131&startDate=" + this.filters.startDate + "&endDate=" + this.filters.endDate)

            await axios.get(
                this.$store.state.ws_url + "/dashboard/data?uid=1&sid=1232131&startDate=" + this.filters.startDate + "&endDate=" + this.filters.endDate
                /*
                this.$store.state.ws_url + "/dashboard/data", {
                    params: {
                        startDate: this.filters.startDate,
                        endDate: this.filters.endDate,
                        uid: 1,
                        sid: 123213213123
                    }
                }*/
            ).then(function(resp) {
                s.items = resp.data.obj;
            }).catch(function(error) {
                console.log(error)
                toast ({
                type: VueNotifications.types.error,
                title: 'Permissão',
                message: 'Sem permissão de acesso. Verifique o acesso Dados de Referência.',
                timeout: 5000
                })
            })        
        },

        handleResize() {
        },

        refreshData() {
            this.getTotal(1)
            this.getTotal(2)
            this.getTotal(3)

            this.getChart('D1C1')
            this.getChart('D2C1')
            this.getChart('D2C2')
            this.getChart('D2C3')
            this.getChart('D2C4')
            this.getChart('D2C5')
            this.getChart('D3C1')
            this.getChart('D3C2')
            this.getChart('D3C3')

            this.refreshDataTable()            
        }
    },
    mounted: function() {
        window.addEventListener('resize', this.handleResize);
        this.refreshData();
    },
    beforeDestroy() {
        window.removeEventListener('resize', this.handleResize);
    }
}
</script>

<style scoped>
table#table-transition-example .flip-list-move {
    transition: transform 1s;
}
.vue-gauge__label {
  font-size: 1.5rem;
  font-weight: bold;
  color: #410082; /* Example: purple color */
  text-shadow: 1px 1px 2px #eee;
}

.chart-wrapper {
  height: 300px;
  min-height: 300px;
  max-height: 300px;
  display: flex;
  align-items: center;
  justify-content: center;
}
</style>